import axios from "axios";
import { API } from "../config";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

class DadosGeograficosService {
  getEstados() {
    return axios.get(API + "/estados");
  }

  getBairros() {
    return axios.get(API + "/bairros");
  }

  getMunicipios() {
    return axios.get(API + "/municipios");
  }

  getMunicipiosLogado() {
    return axios.get(API + "/municipios/usuario-logado");
  }

  pesquisarMunicipios(id) {
    return axios.get(API + "/municipios/listar-por-estado/" + id);
  }

  pesquisarMunicipiosArray(idsEstados) {
    return axios.get(API + "/municipios/listar-por-estado", {
      params: {
        estados: idsEstados,
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });
  }

  pesquisarBairros(id) {
    return axios.get(API + "/bairros/listar-por-municipio/" + id);
  }

  pesquisarBairrosArray(idMunicipio) {
    const municipiosValidos = Array.isArray(idMunicipio)
      ? idMunicipio.filter((id) => id !== "" && id !== null && id !== undefined)
      : [];

    const params = {};

    if (municipiosValidos.length > 0) {
      params.municipios = municipiosValidos;
    }

    return axios.get(API + "/bairros/listar-por-municipio", {
      params,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });
  }

  getNacionalidades() {
    return axios.get(API + "/nacionalidades");
  }
}

const instanceDadosGeograficos = new DadosGeograficosService();
export default instanceDadosGeograficos;
